module.exports = __webpack_public_path__ + "img/Pot3.svg";